'use strict';

export default class AdminController {
  users: Object[];

  /*@ngInject*/
  constructor(User) {
    // Use the User $resource to fetch all users
    this.users = User.query();
  }

  delete(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js